import { groups, isOn, selectAll, selectNone, selectedCount, toggle } from "../lib/parameters.js";

// Which parameters an issue writes. Logic lives in lib/parameters.js.
export default function ParameterPicker({ catalog, selection, onChange }) {
  const total = catalog?.parameters?.length || 0;
  return (
    <div className="chaos-picker">
      <div className="chaos-picker-head">
        <span>Parameters <em>{selectedCount(selection, catalog)} / {total}</em></span>
        <span className="chaos-picker-bulk">
          <button type="button" className="btn btn-ghost btn-xs" onClick={() => onChange(selectAll())}>All</button>
          <button type="button" className="btn btn-ghost btn-xs" onClick={() => onChange(selectNone())}>None</button>
        </span>
      </div>
      {groups(catalog).map((g) => (
        <fieldset key={g.label} className="chaos-picker-group">
          <legend>{g.label}</legend>
          {g.params.map((p) => (
            <label key={p.name} className="chaos-toggle">
              <input type="checkbox" checked={isOn(selection, p.name)} onChange={() => onChange(toggle(selection, p.name, catalog))} /> {p.label}
            </label>
          ))}
        </fieldset>
      ))}
    </div>
  );
}
